import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environment/environment';

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.issuer,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        redirectUri: environment.paths.base + '/',
        checkLoginIframe: false,
      },
    });
}
